const FILE_STATUS = {
  success: 'success',
  fail: 'fail',
};

export { FILE_STATUS };
